// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"b68e019c","697":"7d59cc0a","787":"6df47463"}[chunkId] + ".chunk.js";
};